import { render, staticRenderFns } from "./Twitch.vue?vue&type=template&id=46f77c54&"
import script from "./Twitch.vue?vue&type=script&lang=js&"
export * from "./Twitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports